import React from 'react'

interface CardProps extends React.HTMLAttributes<HTMLElement> {
  children: React.ReactNode
}

export const Card = React.forwardRef<HTMLElement, CardProps>(
  ({ children, className = '', ...props }, ref) => {
    return (
      <article
        ref={ref}
        className={`w-full bg-white border border-brand-border-light rounded-2xl p-8 lg:p-10 shadow-xl shadow-zinc-100/50 flex flex-col gap-6 ${className}`}
        {...props}
      >
        {children}
      </article>
    )
  },
)

Card.displayName = 'Card'
